import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export default function PlotsList() {
  const [plots, setPlots] = useState([]);
  useEffect(() => { api.get("/plots").then((r) => setPlots(r.data)); }, []);

  return (
    <div className="p-6 md:p-10 max-w-6xl">
      <h1 className="heading text-3xl md:text-4xl">Plots</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6" data-testid="plots-grid">
        {plots.map((p) => (
          <Link key={p.id} to={`/app/plots/${p.id}`} className="border border-border rounded-lg bg-card overflow-hidden hover:-translate-y-0.5 transition-transform duration-200" data-testid={`plot-card-${p.plot_number}`}>
            <img src="https://images.unsplash.com/photo-1560198927-b31ef30c5867?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxmYXJtbGFuZCUyMGFlcmlhbCUyMHZpZXd8ZW58MHx8fHwxNzg2NjE3MjczfDA&ixlib=rb-4.1.0&q=85" alt="" className="w-full max-h-[160px] object-cover" />
            <div className="p-4">
              <div className="flex items-center justify-between">
                <div className="font-medium">Plot {p.plot_number}</div>
                {p.has_cottage && <span className="text-[10px] uppercase tracking-widest bg-primary/10 text-primary rounded px-2 py-0.5">Cottage</span>}
              </div>
              <div className="text-xs text-muted-foreground mt-1">{p.size_sqft ? `${Math.round(p.size_sqft).toLocaleString("en-IN")} sq ft` : "—"} · {p.status}</div>
            </div>
          </Link>
        ))}
        {plots.length === 0 && <div className="text-sm text-muted-foreground">No plots.</div>}
      </div>
    </div>
  );
}
